import React from 'react'
import { Text, View } from 'react-native'
import { BlockComponentProps } from '../../types'
import { typography } from '../../tokens'
import { useDocletLayout } from '../../DocletLayoutContext'
import InlineTextInput from '../../InlineTextInput'

// Legacy equivalent: a `header` (h1) item followed by a `subheader` (h2) item
const TitleBlock = ({
  block,
  editable = false,
  onChange,
  onFocus
}: BlockComponentProps<'title'>) => {
  const { isWide } = useDocletLayout()
  const { title, subtitle } = block.props
  const titleStyle = typography.title(isWide)
  const subtitleStyle = typography.subtitle(isWide)

  if (editable) {
    return (
      <View>
        <InlineTextInput
          value={title}
          placeholder="Title"
          accessibilityLabel="Title"
          textStyle={titleStyle}
          onFocus={onFocus}
          onChangeText={value => onChange?.({ ...block.props, title: value })}
        />
        <InlineTextInput
          value={subtitle}
          placeholder="Subtitle"
          accessibilityLabel="Subtitle"
          textStyle={subtitleStyle}
          onFocus={onFocus}
          onChangeText={value =>
            onChange?.({ ...block.props, subtitle: value })
          }
        />
      </View>
    )
  }

  // Empty fields are left out of the rendered page entirely
  return (
    <View>
      {!!title.trim() && (
        <Text accessibilityRole="header" style={titleStyle}>
          {title}
        </Text>
      )}
      {!!subtitle.trim() && <Text style={subtitleStyle}>{subtitle}</Text>}
    </View>
  )
}

export default TitleBlock
